import { render, staticRenderFns } from "./JobSettings.vue?vue&type=template&id=b5379bb8&scoped=true"
import script from "./JobSettings.vue?vue&type=script&lang=js"
export * from "./JobSettings.vue?vue&type=script&lang=js"
import style0 from "./JobSettings.vue?vue&type=style&index=0&id=b5379bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5379bb8",
  null
  
)

export default component.exports